export default "__VITE_ASSET__CAIA9msT__"